import type { FC } from 'react';
import styled from 'styled-components';
import { NamedContentEntryText } from '../ContentEntryText/NamedContentEntryText';
import { LeaderboardUI } from './LeaderboardUI';
import { withErrorBoundaries } from '../../lib/decorators/withErrorBoundaries';
import { CardErrorView } from '../ErrorView/CardErrorView';
import { Modal } from '../Modal';
import { ModalSize } from '../Modal/Modal';

type LeaderboardModalModalProps = {
  isOpen: boolean;
  onClose: () => void;
  isManager?: boolean;
};

export const LeaderboardModal: FC<LeaderboardModalModalProps> = ({
  isOpen,
  onClose,
  isManager,
}: LeaderboardModalModalProps) => {
  const { LeaderboardUI_WithErrorBoundary } = withErrorBoundaries(
    {
      LeaderboardUI,
    },
    CardErrorView,
  );

  return (
    <Modal
      isOpen={isOpen}
      title={<NamedContentEntryText container="span" refKey="menuSystem" subKey="leaderboard" />}
      onClose={onClose}
      size={ModalSize.LARGE}
    >
      <ModalContainer>
        <LeaderboardUI_WithErrorBoundary isManager={isManager} />
      </ModalContainer>
    </Modal>
  );
};

const ModalContainer = styled.div`
  padding: 0px 16px;
`;
